import BaseApi from '@/api/BaseApi';

export class BrokerApi extends BaseApi {
    static resource = 'brokers';
}

export default BrokerApi;
